
import { Component, Vue, Watch } from "vue-property-decorator";
import moment, { lang } from "moment";

@Component({
  components: {
    ProfileMenu: () => import("@/components/Jobs/Profile/ProfileMenu.vue"),
    AddPhone: () => import("@/components/Jobs/Profile/AddPhone.vue"),
    ProfileInformation: () =>
      import("@/components/Jobs/Profile/ProfileInformation.vue"),
    AcademicInformation: () =>
      import("@/components/Jobs/Common/AcademicInformation.vue"),
    ProfessionalInformation: () =>
      import("@/components/Jobs/Common/ProfessionalInformation.vue"),
    WorkExperience: () => import("@/components/Jobs/Common/WorkExperience.vue"),
    ExperienceUser: () => import("@/components/Jobs/Common/ExperienceUser.vue"),
    Footer: () => import("@/components/Jobs/Homepage/Footer.vue"),
    UserLanguage: () => import("@/components/Jobs/Common/UserLanguage.vue"),
    UserSkills: () => import("@/components/Jobs/Common/UserSkills.vue"),
    AttachFile: () => import("@/components/Jobs/Common/AttachFile.vue")
  },
  computed: {
    optionToolFiltered() {
      return (this as any).optionTool.filter(
        (l: any) =>
          ((this as any).preserve_skill_id &&
            parseInt((this as any).preserve_skill_id) ===
              parseInt(l.external_id)) ||
          !(
            (this as any).user.nucleus_user.conocimientosCV &&
            (this as any).user.nucleus_user.conocimientosCV.some(
              (ul: any) =>
                parseInt(ul.oi_conocimiento) === parseInt(l.external_id)
            )
          )
      );
    },
    optionsLangFiltered() {
      return (this as any).optionsLang.filter(
        (l: any) =>
          ((this as any).preserve_lang_id &&
            parseInt((this as any).preserve_lang_id) ===
              parseInt(l.external_id)) ||
          !(
            (this as any).user.users_languages &&
            (this as any).user.users_languages.some(
              (ul: any) => parseInt(ul.language) === parseInt(l.external_id)
            )
          )
      );
    },
    user_level() {
      if (
        !this.$store.state.user.users_educations ||
        !this.$store.state.user.users_educations.length
      )
        return "";
      let str: any = (this as any).levels.find(
        (i: any) =>
          i.id === this.$store.state.user.users_educations[0].study_level
      );
      return str ? str.description : "";
    },
    user_level_status() {
      if (
        !this.$store.state.user.users_educations ||
        !this.$store.state.user.users_educations.length
      )
        return "";
      let str: any = (this as any).educationStatus.find(
        (i: any) =>
          i.id === this.$store.state.user.users_educations[0].study_status
      );
      return str ? str.description : "";
    },
    area_label() {
      if (!this.$store.state.user.users_professional) return "";
      let str: any = (this as any).areas.find(
        (i: any) => i.id === this.$store.state.user.users_professional.areaId
      );
      return str ? str.description : "";
    },
    localidad_label() {
      if (!this.$store.state.user.users_professional) return "";
      let str: any = (this as any).cities.find(
        (i: any) =>
          i.id === this.$store.state.user.users_professional.locationId
      );
      return str ? str.label : "";
    },
    user_location() {
      let str = "";
      if (
        !(this as any).$store.state.user &&
        !(this as any).$store.state.user.nucleus_user
      )
        return "";
      str =
        ((this as any).$store.state.user.nucleus_user.d_calle
          ? (this as any).$store.state.user.nucleus_user.d_calle
          : "") +
        " " +
        ((this as any).$store.state.user.nucleus_user.c_nro
          ? (this as any).$store.state.user.nucleus_user.c_nro
          : "") +
        " " +
        ((this as any).$store.state.user.nucleus_user.c_piso
          ? (this as any).$store.state.user.nucleus_user.c_piso
          : "") +
        " " +
        ((this as any).$store.state.user.nucleus_user.c_departamento
          ? (this as any).$store.state.user.nucleus_user.c_departamento
          : "");
      if (
        (this as any).$store.state.user &&
        (this as any).$store.state.user.nucleus_user &&
        (this as any).$store.state.user.nucleus_user.oi_localidad
      ) {
        if ((this as any).location_label && (this as any).location_label[0]) {
          str = str + " " + (this as any).location_label[0].label;
        }
      }
      return str;
    },
    user_nacionality() {
      if (
        !this.$store.state.user.nucleus_user &&
        !this.$store.state.user.nucleus_user.oi_nacionalidad
      )
        return "";
      let str: any = (this as any).nationality.find(
        (i: any) =>
          i.external_id === this.$store.state.user.nucleus_user.oi_nacionalidad
      );
      return str ? str.description : "";
    }
  },
  filters: {
    date_format(value: any) {
      return moment(value).isValid()
        ? moment(value).format("DD/MM/YYYY")
        : moment().format("DD/MM/YYYY");
    }
  }
})
export default class MyProfile extends Vue {
  showPhoneModal = false;
  user = {};
  levels = [];
  areas = [];
  cities = [];
  optionsLvl = [];
  optionsLang = [];
  optionTool = [];
  optionsStatus = [];
  educationLvl = [];
  educationCareer = [];
  educationStatus = [];
  nationality = [];
  validate: boolean = false;
  preserve_skill_id = null;
  preserve_lang_id = null;
  viewsIsEditing = {
    profile: false,
    academy: false,
    professional: false,
    experience: false,
    language: false,
    computing_skills: false
  };
  workExp = {
    title: "",
    nucleusTypeId: "",
    company: "",
    from: "",
    to: "",
    description: "",
    current_job: false
  };
  userDataL = {
    language: "",
    writing_level: ""
  };
  userSkill = {
    c_nivel: "",
    oi_conocimiento: "",
    d_conoc_cv: ""
  };
  userAcademic = {
    study_level: "",
    study_status: "",
    study: "",
    university: ""
  };
  user_exp = {};
  new_profile_pic = null;
  modality = false;
  notPhone = false;
  add_edit_experience = false;
  errorPhone = {
    flag: true,
    type: ""
  };
  is_edit_academic = true;
  edit_index = null;
  user_edit = true;
  is_edit_language = true;
  edit_index_lang = null;
  user_edit_copy = {};
  element_delete = {
    index: null,
    element: {}
  };
  location_label = "";
  location_label_professional = "";
  show_delete_edit = true;
  show_delete_edit_lang = true;
  is_edit_skill = true;
  edit_index_skill = null;
  show_delete_edit_skill = true;
  no_pointer = false;
  userError = false;
  phone = {
    phonepais: "",
    phonearea: null,
    phone: null
  };
  secondphone = {
    phonepais: "",
    phonearea: null,
    phone: null
  };

  @Watch("user.users_professional", { deep: true })
  onChangeModality() {
    if ((this as any).user.users_professional) {
      if (
        (this as any).user.users_professional.is_part_time ||
        (this as any).user.users_professional.is_full_time ||
        (this as any).user.users_professional.is_remote ||
        (this as any).user.users_professional.is_temporal
      )
        this.modality = false;
    }
  }
  @Watch("viewsIsEditing", { deep: true })
  noEvents() {
    this.no_pointer = false;
    Object.keys((this as any).viewsIsEditing).forEach(key => {
      if ((this as any).viewsIsEditing[key] && !this.no_pointer) {
        this.no_pointer = true;
        return;
      }
    });
  }
  async getLocation(id: any, type: any) {
    if (
      id &&
      (this as any).$store.state.user &&
      (this as any).$store.state.user
        .nucleus_user /* &&
      (this as any).$store.state.user.nucleus_user.oi_localidad*/
    ) {
      return new Promise((accept: any) => {
        (this as any).$root
          ._get(`misc/locations?` + type + `=${id}`, {})
          .then((response: any) => {
            accept(response);
          });
      });
    }
  }
  newImage(val: string) {
    (this as any).new_profile_pic = val;
  }
  toggleViewState(key: string) {
    (this as any).viewsIsEditing[key] = !(this as any).viewsIsEditing[key];
  }
  closeAddPhone() {
    this.showPhoneModal = !this.showPhoneModal;
  }
  customFormatter(date: any) {
    if (date) {
      return moment(date).format("DD-MM-YYYY");
    } else return "";
  }

  sortByDate(a: any, b: any) {
    return moment(a.from).isBefore(moment(b.from));
  }

  loadTypes() {
    let types: any = [
      { key: "NIV_IDIOMA", model: "optionsLvl" },
      { key: "NIVELES_EST", model: "levels" },
      { key: "NIVELES_EST", model: "educationLvl" },
      { key: "IDIOMAS", model: "optionsLang" },
      { key: "CONOCIMIENTOS", model: "optionTool" },
      { key: "NIV_CONOCIMIENTOS", model: "optionsStatus" },
      { key: "TIPOS_PUESTO", model: "optionsEmp" },
      { key: "TIPOS_DOC", model: "typeDoc" },
      { key: "NACIONALIDADES", model: "nationality" },
      { key: "PAISES", model: "countries" },
      { key: "ESTUDIOS", model: "educationCareer" },
      { key: "ESTADOS_EST", model: "educationStatus" }
    ];
    types.forEach((t: any) => {
      (this as any).$root._get(`nucleus_types/${t.key}`).then((data: any) => {
        (this as any)[t.model] = data.data.map((item: any) => {
          return { ...item, label: item.description };
        });
      });
    });
  }

  async mounted() {
    const _this: any = this;
    _this.$root.isUser = true;
    this.user_exp = this.$store.state.user.users_experiences;
    let tempUser: any = JSON.parse(JSON.stringify(this.$store.state.user));
    if (!tempUser.users_professional)
      tempUser.users_professional = {
        lowest_expected_salary: 0,
        highest_expected_salary: 200000,
        profession: "",
        area: "",
        desired_place_lat: ""
      };
    if (tempUser.about === "null") tempUser.about = "";
    this.user = tempUser;
    if (!_this.$store.state.user.second_phone) {
      this.showPhoneModal = true;
    }

    _this.loadTypes();
    _this.$root._get(`area`).then((data: any) => {
      _this.areas = data.data.map((item: any) => {
        return { ...item, label: item.description };
      });
    });

    if (
      _this.user.users_professional &&
      _this.user.users_professional.locationId
    ) {
      (this as any).$root
        ._get(
          `misc/locations?id=${_this.user.users_professional.locationId}`,
          {}
        )
        .then((resp: any) => {
          _this.cities = resp;
        });
    }
    if (
      (this as any).$store.state.user &&
      (this as any).$store.state.user.nucleus_user &&
      (this as any).$store.state.user.nucleus_user.oi_localidad
    ) {
      this.getLocation(
        (this as any).$store.state.user.nucleus_user.oi_localidad,
        "external_id"
      ).then((resp: any) => {
        (this as any).location_label = resp;
      });
    }

    if (
      (this as any).$store.state.user.users_professional &&
      (this as any).$store.state.user.users_professional.locationId
    ) {
      this.getLocation(
        (this as any).$store.state.user.users_professional.locationId,
        "id"
      ).then((resp: any) => {
        (this as any).location_label_professional = resp;
      });
    }
  }
  async removeCv() {
    const _this: any = this;
    await _this.$root._put("user/" + _this.user.id, {
      cv: null,
      cv_uploaded_at: null
    });
    (this as any).$refs.container_file.style.pointerEvents = "auto";
    await _this.$root.reloadUser();
    _this.user = _this.$store.state.user;
    if (_this.user.about === "null") _this.user.about = "";
  }
  async updateJobsOffers() {
    const _this: any = this;
    const response: any = await _this.$root._put(
      `userprofessional/${_this.user.users_professional.id}`,
      {
        wants_job_offers: _this.user.users_professional.wants_job_offers
      }
    );
    await (this as any).$root.reloadUser();
  }
  async save_profile_personal() {
    const _this: any = this;

    let phone1 = "";
    let phone2 = "";
    let phone: any = "";
    let second_phone: any = "";

    if (
      (this as any).phone.phone !== "" ||
      (this as any).phone.phonepais !== "" ||
      (this as any).phone.phonearea !== ""
    ) {
      phone1 = `${(this as any).$root.getPhoneCountryCode(
        (this as any).phone.phonepais
      )}${(this as any).$root.getPhoneAreaCode(
        (this as any).phone.phonearea
      )}${(this as any).$root.getPhoneNumber((this as any).phone.phone)}`;
      phone = _this.$root.parsePhone(phone1);
    }

    if (
      (this as any).secondphone.phone ||
      (this as any).secondphone.phonepais ||
      (this as any).secondphone.phonearea
    ) {
      phone2 = `${(this as any).$root.getPhoneCountryCode(
        (this as any).secondphone.phonepais
      )}${(this as any).$root.getPhoneAreaCode(
        (this as any).secondphone.phonearea
      )}${(this as any).$root.getPhoneNumber((this as any).secondphone.phone)}`;
      second_phone = _this.$root.parsePhone(phone2);
    }

    let phone_true = true;
    this.errorPhone = (this as any).$root.validateNumber(phone1);
    if (phone1 !== "" && phone1 !== null && !(this as any).errorPhone.flag) {
      phone_true = false;
    }
    let elements = [
      "first_name",
      "last_name",
      "email",
      "birthday",
      "dni",
      "dni_type"
    ];
    await _this.$root.validateBeforeSubmit(elements, _this.user);
    if (
      !_this.user.nucleus_user.oi_localidad ||
      _this.user.nucleus_user.oi_localidad === ""
    ) {
      (this as any).$root.error_bt.push("oi_localidad");
    }
    if (
      !_this.user.nucleus_user.oi_nacionalidad ||
      _this.user.nucleus_user.oi_nacionalidad === ""
    ) {
      (this as any).$root.error_bt.push("oi_nacionalidad");
    }

    if (
      (this as any).$root.error_bt.indexOf("birthday") < 0 &&
      (this as any).$root.isUnder18(_this.user.birthday)
    ) {
      (this as any).$root.error_bt.push("birthday");
    }

    if ((this as any).$root.error_bt.length === 0) {
      if (phone_true) {
        (this as any).$refs.loader_ref_profile.style.display = "flex";
        let nu = JSON.parse(
          JSON.stringify(_this.$store.state.user.nucleus_user)
        );
        nu.c_nro_doc = _this.user.dni;
        nu.oi_tipo_documento =
          _this.user.dni_type && _this.user.dni_type.external_id
            ? _this.user.dni_type.external_id
            : null;
        nu.d_apellido = _this.user.last_name;
        nu.d_email = _this.user.email;
        nu.d_nombres = _this.user.first_name;
        if (typeof phone === "object") {
          nu.te_celular = phone.nu_nro;
          nu.c_area_cel = phone.nu_area;
          nu.c_pais_cel = phone.nu_pais;
        } else if (phone === "") {
          nu.te_celular = "";
          nu.c_area_cel = "";
          nu.c_pais_cel = "";
        }
        if (typeof second_phone === "object") {
          nu.te_nro = second_phone.nu_nro;
          nu.c_area = second_phone.nu_area;
          nu.c_pais = second_phone.nu_pais;
        }
        if (second_phone === "") {
          nu.te_nro = "";
          nu.c_area = "";
          nu.c_pais = "";
        }
        nu.f_nacim = _this.user.birthday;
        nu.d_calle = _this.user.nucleus_user.d_calle;
        nu.oi_nacionalidad = _this.user.nucleus_user.oi_nacionalidad
          ? typeof _this.user.nucleus_user.oi_nacionalidad === "number"
            ? _this.user.nucleus_user.oi_nacionalidad
            : _this.user.nucleus_user.oi_nacionalidad.external_id
          : "";
        nu.oi_pais =
          typeof _this.user.nucleus_user.oi_localidad === "object"
            ? _this.user.nucleus_user.oi_localidad.pais_id
            : _this.user.nucleus_user.oi_pais
            ? _this.user.nucleus_user.oi_pais
            : "";
        nu.oi_localidad = _this.user.nucleus_user.oi_localidad
          ? typeof _this.user.nucleus_user.oi_localidad === "object"
            ? _this.user.nucleus_user.oi_localidad.external_id
            : _this.user.nucleus_user.oi_localidad
          : "";
        nu.oi_provincia =
          typeof _this.user.nucleus_user.oi_localidad === "object"
            ? _this.user.nucleus_user.oi_localidad.prov_id
            : _this.user.nucleus_user.oi_provincia
            ? _this.user.nucleus_user.oi_provincia
            : "";
        nu.c_piso = _this.user.nucleus_user.c_piso;
        nu.c_nro = _this.user.nucleus_user.c_nro;
        nu.c_departamento = _this.user.nucleus_user.c_departamento;

        if (nu.estudiosCV.length) {
          nu.estudiosCV[0].oi_nivel_estudio =
            _this.user.educationLevelId &&
            _this.user.educationLevelId.external_id
              ? _this.user.educationLevelId.external_id
              : null;
        } else {
          nu.estudiosCV = [
            {
              d_otro_est_educ: "",
              oi_nivel_estudio:
                _this.user.educationLevelId &&
                _this.user.educationLevelId.external_id
                  ? _this.user.educationLevelId.external_id
                  : null,
              oi_estado_est: "",
              oi_estudio: ""
            }
          ];
        }
        let payload: any = {
          id: _this.user.id,
          first_name: _this.user.first_name,
          address: _this.user.nucleus_user.d_calle,
          birthday: _this.user.birthday,
          last_name: _this.user.last_name,
          email: _this.user.email,
          username: _this.user.email,
          phone: phone1,
          second_phone: phone2,
          dni: _this.user.dni,
          dni_type:
            _this.user.dni_type && _this.user.dni_type.id
              ? _this.user.dni_type.id
              : null,
          about: _this.user.about,
          nucleus_user: nu
        };
        if (this.new_profile_pic) {
          const _this: any = this;
          var fd = new FormData();
          fd.append("profile_pic", _this.new_profile_pic);
          fd.append("first_name", payload.first_name);
          fd.append("last_name", payload.last_name);
          fd.append("address", payload.address);
          fd.append("birthday", payload.birthday);
          fd.append("email", payload.email);
          fd.append("username", payload.username);
          fd.append("phone", payload.phone);
          fd.append("dni", payload.dni);
          fd.append("dni_type", payload.dni_type);
          fd.append("about", payload.about);
          // fd.append("nucleus_user", nu);
          payload = fd;
        }
        try {
          let response = await _this.$root._put(
            "user/" + _this.user.id,
            payload
          );
          if (response) {
            _this.toggleViewState("profile");
            (this as any).$refs.loader_ref_profile.style.display = "none";
            (this as any).no_pointer = false;
          }
        } catch (e) {
          this.userError = true;
          (this as any).$refs.loader_ref_profile.style.display = "none";
          return;
        }
        if (_this.user.users_educations && _this.user.users_educations.length) {
          await _this.$root._put(
            "usereducation/" + _this.user.users_educations[0].id,
            {
              study_level:
                _this.user.educationLevelId && _this.user.educationLevelId.id
                  ? _this.user.educationLevelId.id
                  : null
            }
          );
        } else {
          await _this.$root._post("usereducation/", {
            study_level:
              _this.user.educationLevelId && _this.user.educationLevelId.id
                ? _this.user.educationLevelId.id
                : null,
            userId: this.$store.state.user.id
          });
        }
        await _this.$root.reloadUser();
        _this.user = _this.$store.state.user;
        if (_this.user.about === "null") _this.user.about = "";
        if (_this.user.second_phone) {
          this.showPhoneModal = false;
        }
      } else {
        if (!phone_true) _this.notPhone = true;
      }
      if (
        (this as any).$store.state.user.nucleus_user &&
        (this as any).$store.state.user.nucleus_user.oi_localidad
      ) {
        (this as any).location_label = await this.getLocation(
          (this as any).$store.state.user.nucleus_user.oi_localidad,
          "external_id"
        );
      }

      if (!this.$store.state.user.active)
        return ((window as any).location = "/crear-cuenta");
    }
  }
  async save_profile_professional() {
    const _this: any = this;
    if (
      !(this as any).user.users_professional.is_part_time &&
      !(this as any).user.users_professional.is_full_time &&
      !(this as any).user.users_professional.is_remote &&
      !(this as any).user.users_professional.is_temporal
    ) {
      this.modality = true;
    } else {
      this.modality = false;
    }

    if (
      (this as any).user.users_professional.area &&
      (this as any).user.users_professional.profession &&
      (this as any).user.users_professional.desired_place_lat &&
      !this.modality
    ) {
      let data: any = {
        profession: _this.user.users_professional.profession,
        desired_place_lat: null,
        desired_place_lng: null,
        lowest_expected_salary:
          _this.user.users_professional.lowest_expected_salary,
        highest_expected_salary:
          _this.user.users_professional.highest_expected_salary,
        wants_job_offers: _this.user.users_professional.wants_job_offers,
        is_part_time: _this.user.users_professional.is_part_time
          ? _this.user.users_professional.is_part_time
          : 0,
        is_full_time: _this.user.users_professional.is_full_time
          ? _this.user.users_professional.is_full_time
          : 0,
        is_remote: _this.user.users_professional.is_remote
          ? _this.user.users_professional.is_remote
          : 0,
        is_temporal: _this.user.users_professional.is_temporal
          ? _this.user.users_professional.is_temporal
          : 0,
        areaId: _this.user.users_professional.area.id,
        locationId: _this.user.users_professional.desired_place_lat.id
      };
      (this as any).$refs.loader_ref_professional.style.display = "flex";
      if (!_this.user.users_professional.id) {
        const response: any = await _this.$root._post(`userprofessional`, data);
        await (this.$root as any)._put(
          "user/" + (this as any).$store.state.user.id,
          { usersProfessionalId: response.id }
        );
        if (response) {
          (this as any).$refs.loader_ref_professional.style.display = "none";
          (this as any).no_pointer = false;
        }
      } else {
        const response: any = await _this.$root._put(
          `userprofessional/${_this.user.users_professional.id}`,
          data
        );
        if (response) {
          (this as any).$refs.loader_ref_professional.style.display = "none";
          (this as any).no_pointer = false;
        }
      }
      await (this as any).$root.reloadUser();
      (this as any).user = (this as any).$store.state.user;
      (this as any).viewsIsEditing.professional = false;
      this.modality = false;
      if (
        (this as any).user.users_professional &&
        (this as any).user.users_professional.locationId
      ) {
        (this as any).location_label_professional = await this.getLocation(
          (this as any).user.users_professional.locationId,
          "id"
        );
      }
    } else {
      if (
        !(this as any).user.users_professional.area ||
        (this as any).user.users_professional.area === ""
      )
        (this as any).user.users_professional.area = null;
      if (
        !(this as any).user.users_professional.profession ||
        (this as any).user.users_professional.profession === ""
      )
        (this as any).user.users_professional.profession = null;
      if (
        !(this as any).user.users_professional.desired_place_lat ||
        (this as any).user.users_professional.desired_place_lat === ""
      )
        (this as any).user.users_professional.desired_place_lat = null;
    }
  }
  async save_profile_academic() {
    const _this: any = this;
    let nu = this.$store.state.user.nucleus_user;
    let elementD = {};
    if (
      (this as any).userAcademic.study_level !== "" &&
      (this as any).userAcademic.study_status !== "" &&
      (this as any).userAcademic.study !== "" &&
      (this as any).userAcademic.university !== ""
    ) {
      (this as any).$refs.loader_ref_academic.style.display = "flex";
      elementD = {
        d_otro_est_educ: (this as any).userAcademic.university,
        oi_nivel_estudio: (this as any).userAcademic.study_level.external_id,
        oi_estado_est: (this as any).userAcademic.study_status.external_id,
        oi_estudio: (this as any).userAcademic.study.external_id
      };
      let response = await _this.$root._post("usereducation", {
        study_level: (this as any).userAcademic.study_level.id,
        study_status: (this as any).userAcademic.study_status.id,
        study: (this as any).userAcademic.study.id,
        university: (this as any).userAcademic.university,
        userId: this.$store.state.user.id
      });

      if (response) {
        (this as any).$refs.loader_ref_academic.style.display = "none";
        (this as any).show_delete_edit = true;
        (this as any).no_pointer = false;
      }

      if (
        !(this as any).user.users_educations ||
        !(this as any).user.users_educations.length
      ) {
        nu.estudiosCV = [elementD];
      } else {
        nu.estudiosCV.push(elementD);
      }

      await (this as any).$root._put("user/" + (this as any).user.id, {
        nucleus_user: nu
      });

      await (this as any).$root.reloadUser();
      this.user = this.$store.state.user;

      if ((this as any).user.about === "null") (this as any).user.about = "";

      (this as any).userAcademic.study_level = "";
      (this as any).userAcademic.study_status = "";
      (this as any).userAcademic.study = "";
      (this as any).userAcademic.university = "";
      this.toggleViewState("academy");
    }
  }
  async save_language() {
    const _this: any = this;
    let nu = this.$store.state.user.nucleus_user;
    let flag_repeat = false;
    let elementD = {};
    if (
      _this.userDataL.language !== "" &&
      _this.userDataL.language !== null &&
      _this.userDataL.writing_level !== "" &&
      _this.userDataL.writing_level !== null
    ) {
      if (_this.user.users_languages && _this.user.users_languages.length) {
        _this.user.users_languages.forEach((item: any) => {
          if (
            item.language === _this.userDataL.language.external_id.toString() &&
            !flag_repeat
          ) {
            flag_repeat = true;
          }
        });
      }
      if (!flag_repeat) {
        (this as any).$refs.loader_ref_lang.style.display = "flex";
        elementD = {
          l_certificado: "",
          oi_idioma: _this.userDataL.language.external_id,
          oi_nivel_escribe: _this.userDataL.writing_level.external_id,
          oi_nivel_habla: _this.userDataL.writing_level.external_id,
          oi_nivel_lee: _this.userDataL.writing_level.external_id
        };
        let response = await _this.$root._post("userlanguage", {
          language: _this.userDataL.language.external_id,
          speaking_level: _this.userDataL.writing_level.external_id,
          reading_level: _this.userDataL.writing_level.external_id,
          writing_level: _this.userDataL.writing_level.external_id,
          userId: _this.$store.state.user.id
        });
        if (!nu.idiomasCV || !nu.idiomasCV.length) {
          nu.idiomasCV = [elementD];
        } else {
          nu.idiomasCV.push(elementD);
        }
        if (response) {
          (this as any).$refs.loader_ref_lang.style.display = "none";
          (this as any).show_delete_edit_lang = true;
          (this as any).no_pointer = false;
        }
        await (this as any).$root._put("user/" + (this as any).user.id, {
          nucleus_user: nu
        });
        await (this as any).$root.reloadUser();
        this.user = this.$store.state.user;
        if ((this as any).user.about === "null") (this as any).user.about = "";
      } else {
        (this as any).show_delete_edit_lang = true;
        (this as any).no_pointer = false;
      }
      this.toggleViewState("language");
      (this as any).userDataL.language = "";
      (this as any).userDataL.writing_level = "";
    } else {
      (this as any).show_delete_edit_lang = true;
      (this as any).no_pointer = false;
    }
  }
  async saveWork(user: any) {
    const _this: any = this;
    let elements = ["title", "nucleusTypeId", "company", "from"];
    if (!_this.workExp.current_job && _this.workExp.to) {
      elements.push("to");
    }
    await _this.$root.validateBeforeSubmit(elements, _this.workExp);
    _this.validate = true;

    if (
      !(this as any).$root.error_bt.length &&
      (this as any).$store.state.user.users_experiences.some((exp: any) => {
        return (
          exp.company.toLowerCase().trim() ===
            _this.workExp.company.toLowerCase().trim() &&
          exp.title.toLowerCase().trim() ===
            _this.workExp.title.toLowerCase().trim() &&
          ((exp.current_job && _this.workExp.current_job) ||
            (moment(exp.from).isBefore(moment(_this.workExp.from)) &&
              moment(exp.to).isAfter(moment(_this.workExp.to))))
        );
      })
    ) {
      (this as any).$root.error_bt = [
        "title",
        "nucleusTypeId",
        "company",
        "from"
      ];
    }

    if (!(this as any).$root.error_bt.length) {
      (this as any).$refs.loader_ref_exp.style.display = "flex";
      let nu = this.$store.state.user.nucleus_user;
      if (nu.expLaboralCV && nu.expLaboralCV.length) {
        nu.expLaboralCV.push({
          d_empresa: _this.workExp.company,
          d_puesto: _this.workExp.title,
          f_egreso: _this.workExp.current_job ? null : _this.workExp.to,
          f_ingreso: _this.workExp.from,
          o_tareas: _this.workExp.description,
          oi_area_lab:
            (_this.workExp.nucleusTypeId &&
              _this.workExp.nucleusTypeId.external_id) ||
            null
        });
      } else {
        nu.expLaboralCV = [
          {
            d_empresa: _this.workExp.company,
            d_puesto: _this.workExp.title,
            f_egreso: _this.workExp.current_job ? null : _this.workExp.to,
            f_ingreso: _this.workExp.from,
            o_tareas: _this.workExp.description,
            oi_area_lab:
              (_this.workExp.nucleusTypeId &&
                _this.workExp.nucleusTypeId.external_id) ||
              null
          }
        ];
      }

      let response1 = await _this.$root._put(
        "user/" + _this.$store.state.user.id,
        {
          nucleus_user: nu
        }
      );

      if (response1) {
        (this as any).$refs.loader_ref_exp.style.display = "none";
        (this as any).add_edit_experience = false;
        (this as any).user_edit = true;
        (this as any).no_pointer = false;
      }

      const response: any = await _this.$root._post("userexperience", {
        title: _this.workExp.title,
        description: _this.workExp.description,
        current_job: _this.workExp.current_job,
        company: _this.workExp.company,
        from: _this.workExp.from,
        to: _this.workExp.current_job ? null : _this.workExp.to,
        nucleusTypeId:
          (_this.workExp.nucleusTypeId && _this.workExp.nucleusTypeId.id) ||
          null,
        userId: _this.$store.state.user.id
      });

      await _this.$root.reloadUser();
      _this.user = _this.$store.state.user;
      if (_this.user.about === "null") _this.user.about = "";
      _this.user_exp = [];
      setTimeout(() => {
        _this.user_exp = _this.$store.state.user.users_experiences;
      }, 250);
      (this as any).workExp = {
        title: "",
        area: "",
        company: "",
        from: "",
        to: "",
        description: "",
        current_job: false
      };
    }
  }
  async save_skills() {
    const _this: any = this;
    let nu = this.$store.state.user.nucleus_user;
    let elementD = {};
    let flag_repeat = false;
    if (
      _this.userSkill.c_nivel !== "" &&
      _this.userSkill.c_nivel !== null &&
      _this.userSkill.oi_conocimiento !== "" &&
      _this.userSkill.oi_conocimiento !== null
    ) {
      if (nu.conocimientosCV && nu.conocimientosCV.length) {
        nu.conocimientosCV.forEach((item: any) => {
          if (
            item.oi_conocimiento ===
              _this.userSkill.oi_conocimiento.external_id &&
            !flag_repeat
          ) {
            flag_repeat = true;
          }
        });
      }

      if (!flag_repeat) {
        (this as any).$refs.loader_ref_skill.style.display = "flex";
        elementD = JSON.parse(
          JSON.stringify({
            c_nivel: _this.userSkill.c_nivel.code,
            oi_conocimiento: _this.userSkill.oi_conocimiento.external_id,
            d_conoc_cv: _this.userSkill.d_conoc_cv
          })
        );
        if (!nu.conocimientosCV || !nu.conocimientosCV.length) {
          nu.conocimientosCV = [elementD];
        } else {
          nu.conocimientosCV.push(elementD);
        }
        let response = await (this as any).$root._put(
          "user/" + (this as any).user.id,
          {
            nucleus_user: nu
          }
        );

        if (response) {
          (this as any).$refs.loader_ref_skill.style.display = "none";
          (this as any).show_delete_edit_skill = true;
          (this as any).no_pointer = false;
        }
        await (this as any).$root.reloadUser();
        this.user = this.$store.state.user;
        if ((this as any).user.about === "null") (this as any).user.about = "";
      } else {
        (this as any).show_delete_edit_skill = true;
        (this as any).no_pointer = false;
      }

      this.toggleViewState("computing_skills");
      (this as any).userSkill.c_nivel = "";
      (this as any).userSkill.oi_conocimiento = "";
      (this as any).userSkill.d_conoc_cv = "";
    } else {
      (this as any).show_delete_edit_skill = true;
      (this as any).no_pointer = false;
    }
  }
  async editAcademic(user: any, index: any) {
    (this as any).$refs.loader_ref_academic.style.display = "flex";
    this.is_edit_academic = true;
    const _this: any = this;
    let nu = this.$store.state.user.nucleus_user;
    let elementD = {};
    let response = await _this.$root._put("usereducation/" + user.id, {
      study_level:
        typeof user.study_level === "object"
          ? user.study_level.id
          : user.study_level,
      study_status:
        typeof user.study_status === "object"
          ? user.study_status.id
          : user.study_status,
      study: typeof user.study === "object" ? user.study.id : user.study,
      university: user.university
    });

    if (response) {
      (this as any).$refs.loader_ref_academic.style.display = "none";
      this.edit_index = null;
      this.show_delete_edit = true;
      this.no_pointer = false;
    }

    elementD = {
      d_otro_est_educ: user.university,
      oi_nivel_estudio:
        typeof user.study_level === "object"
          ? user.study_level.external_id
          : user.study_level,
      oi_estado_est:
        typeof user.study_status === "object"
          ? user.study_status.external_id
          : user.study_status,
      oi_estudio:
        typeof user.study === "object" ? user.study.external_id : user.study
    };

    nu.estudiosCV[index] = elementD;
    await (this as any).$root._put(
      "user/" + (this as any).$store.state.user.id,
      {
        nucleus_user: nu
      }
    );
    await (this as any).$root.reloadUser();
    (this as any).user = (this as any).$store.state.user;
  }
  async editLang(user: any, index: any) {
    (this as any).$refs.loader_ref_lang.style.display = "flex";
    const _this: any = this;
    this.is_edit_language = true;
    let nu = this.$store.state.user.nucleus_user;
    let elementD = {};
    elementD = {
      l_certificado: "",
      oi_idioma:
        typeof user.language === "object"
          ? (user.language = user.language.external_id)
          : user.language,
      oi_nivel_escribe:
        typeof user.writing_level === "object"
          ? (user.writing_level = user.writing_level.external_id)
          : user.writing_level,
      oi_nivel_habla:
        typeof user.writing_level === "object"
          ? (user.writing_level = user.writing_level.external_id)
          : user.writing_level,
      oi_nivel_lee:
        typeof user.writing_level === "object"
          ? (user.writing_level = user.writing_level.external_id)
          : user.writing_level
    };
    let response = await _this.$root._put("userlanguage/" + user.id, {
      speaking_level:
        typeof user.writing_level === "object"
          ? (user.writing_level = user.writing_level.external_id)
          : user.writing_level,
      reading_level:
        typeof user.writing_level === "object"
          ? (user.writing_level = user.writing_level.external_id)
          : user.writing_level,

      writing_level:
        typeof user.writing_level === "object"
          ? (user.writing_level = user.writing_level.external_id)
          : user.writing_level,
      userId: _this.$store.state.user.id,
      language:
        typeof user.language === "object"
          ? (user.language = user.language.external_id)
          : user.language
    });
    nu.idiomasCV[index] = elementD;
    await (this as any).$root._put(
      "user/" + (this as any).$store.state.user.id,
      {
        nucleus_user: nu
      }
    );

    if (response) {
      (this as any).$refs.loader_ref_lang.style.display = "none";
      this.show_delete_edit_lang = true;
      this.no_pointer = false;
      this.edit_index_lang = null;
    }
    await (this as any).$root.reloadUser();
    (this as any).user = (this as any).$store.state.user;
  }
  async editSkill(user: any, index: any) {
    (this as any).$refs.loader_ref_skill.style.display = "flex";
    this.is_edit_skill = true;
    const _this: any = this;
    let nu = this.$store.state.user.nucleus_user;
    let elementD = {};
    elementD = JSON.parse(
      JSON.stringify({
        c_nivel:
          typeof user.c_nivel === "object" ? user.c_nivel.code : user.c_nivel,
        oi_conocimiento:
          typeof user.oi_conocimiento === "object"
            ? user.oi_conocimiento.external_id
            : user.oi_conocimiento,
        d_conoc_cv: user.d_conoc_cv
      })
    );
    nu.conocimientosCV[index] = elementD;
    let response = await (this as any).$root._put(
      "user/" + (this as any).$store.state.user.id,
      {
        nucleus_user: nu
      }
    );
    if (response) {
      (this as any).$refs.loader_ref_skill.style.display = "none";
      this.edit_index_skill = null;
      this.show_delete_edit_skill = true;
      this.no_pointer = false;
    }
    await (this as any).$root.reloadUser();
    (this as any).user = (this as any).$store.state.user;
  }
  async deleteExperience(index: any) {
    let experienceComponent: any = (this as any).$children.find(
      (children: any) => {
        return children.$options._componentTag === "ExperienceUser";
      }
    );
    if (
      experienceComponent &&
      experienceComponent.$refs &&
      experienceComponent.$refs.loader_ref_exp_delete
    )
      experienceComponent.$refs.loader_ref_exp_delete.style.display = "flex";
    const _this: any = this;
    let nu = this.$store.state.user.nucleus_user;
    let newnu = [];
    const response3 = await _this.$root._delete(
      "userexperience/" + _this.$store.state.user.users_experiences[index].id,
      {}
    );
    if (
      response3 &&
      experienceComponent &&
      experienceComponent.$refs &&
      experienceComponent.$refs.loader_ref_exp_delete
    ) {
      experienceComponent.$refs.loader_ref_exp_delete.style.display = "none";
    }
    let element;
    if ((this as any).user.users_experiences.length > 1) {
      for (
        let i: number = 0;
        i < (this as any).user.users_experiences.length;
        i++
      ) {
        if (i !== index) {
          element = {
            d_empresa: _this.user.users_experiences[i].company,
            d_puesto: _this.user.users_experiences[i].title,
            f_egreso: _this.user.users_experiences[i].current_job
              ? null
              : _this.user.users_experiences[i].to,
            f_ingreso: _this.user.users_experiences[i].from,
            o_tareas: _this.user.users_experiences[i].description,
            oi_area_lab:
              (_this.user.users_experiences[i].nucleusTypeId &&
                _this.user.users_experiences[i].nucleusTypeId.external_id) ||
              null
          };
          newnu.push(element);
        }
      }
      nu.expLaboralCV = newnu;
    } else {
      nu.expLaboralCV = [];
    }
    await (this as any).$root._put("user/" + (this as any).user.id, {
      nucleus_user: nu
    });
    await _this.$root.reloadUser();
    _this.user = _this.$store.state.user;
    if (_this.user.about === "null") _this.user.about = "";
    _this.user_exp = [];
    setTimeout(() => {
      _this.user_exp = _this.$store.state.user.users_experiences;
    }, 250);
  }
  async deleteAcademic() {
    const _this: any = this;
    let element = {};
    (this as any).$refs.loader_ref_academic_delete.style.display = "flex";
    let response = await _this.$root._delete(
      "usereducation/" + (this as any).element_delete.element.id,
      {}
    );
    if (response) {
      (this as any).$refs.loader_ref_academic_delete.style.display = "none";
      (this as any).$refs.delete_modal.hide();
    }
    await _this.$root.reloadUser();
    _this.user = _this.$store.state.user;
    if (_this.user.about === "null") _this.user.about = "";
    let nu = (this as any).user.nucleus_user;
    nu.estudiosCV.splice((this as any).element_delete.index, 1);
    await (this as any).$root._put("user/" + (this as any).user.id, {
      nucleus_user: nu
    });
  }
  async deleteLang() {
    (this as any).$refs.loader_ref_lang_delete.style.display = "flex";
    const _this: any = this;
    let element = {};
    let response = await _this.$root._delete(
      "userlanguage/" + (this as any).element_delete.element.id,
      {}
    );
    if (response) {
      (this as any).$refs.loader_ref_lang_delete.style.display = "none";
      (this as any).$refs.delete_modal_idioma.hide();
    }
    let nu = (this as any).user.nucleus_user;
    nu.idiomasCV.splice((this as any).element_delete.index, 1);
    await (this as any).$root._put("user/" + (this as any).user.id, {
      nucleus_user: nu
    });
    await _this.$root.reloadUser();
    _this.user = _this.$store.state.user;
    if (_this.user.about === "null") _this.user.about = "";
  }
  async deleteSkill() {
    (this as any).$refs.loader_ref_skill_delete.style.display = "flex";
    const _this: any = this;
    let nu = (this as any).user.nucleus_user;
    if (nu.conocimientosCV && nu.conocimientosCV.length) {
      nu.conocimientosCV.splice((this as any).element_delete.index, 1);
      let response = await (this.$root as any)._put(
        "user/" + (this as any).$store.state.user.id,
        {
          nucleus_user: nu
        }
      );
      if (response) {
        (this as any).$refs.loader_ref_skill_delete.style.display = "none";
        (this as any).$refs.delete_modal_skill.hide();
      }
      await (this as any).$root.reloadUser();
    }
  }
  getUserLanguage(language: any) {
    let indexL, labelLang;
    let num_id =
      typeof language === "object" ? language.id : parseInt(language);
    if (num_id && this.optionsLang.length) {
      indexL = this.optionsLang.findIndex((i: any) => {
        return i.external_id === num_id;
      });
      if (indexL >= 0) {
        labelLang = (this as any).optionsLang[indexL].label;
        return labelLang;
      }
    }
  }
  getUserLanguageLvl(lvl: any) {
    let indexR, labelLang;
    let num_id = typeof lvl === "object" ? lvl.id : parseInt(lvl);
    if (num_id && (this as any).optionsLvl.length) {
      indexR = (this as any).optionsLvl.findIndex((i: any) => {
        return i.external_id === num_id;
      });
      if (indexR >= 0) {
        labelLang = (this as any).optionsLvl[indexR].label;
        return labelLang;
      }
    }
  }
  getSkill(skill: any) {
    let index, labelSkill;
    if (skill && this.optionTool.length) {
      index = this.optionTool.findIndex((i: any) => {
        return i.external_id === parseInt(skill);
      });
      if (index >= 0) {
        labelSkill = (this as any).optionTool[index].label;
        return labelSkill;
      }
    }
  }
  getSkillStatus(status: any) {
    let index, labelStatus;
    if (status && (this as any).optionsStatus.length) {
      index = (this as any).optionsStatus.findIndex((i: any) => {
        return i.external_id === status || i.code === status;
      });
      if (index >= 0) {
        labelStatus = (this as any).optionsStatus[index].label;
        return labelStatus;
      }
    }
  }
  getEducationLvl(lvl: any) {
    let index, labelLvl;
    let num_id = 0;
    if (lvl) {
      num_id = typeof lvl === "object" ? lvl.id : parseInt(lvl);
      if (lvl && (this as any).educationLvl.length) {
        index = (this as any).educationLvl.findIndex((i: any) => {
          return i.id === num_id;
        });
        if (index >= 0) {
          labelLvl = (this as any).educationLvl[index].label;
          return labelLvl;
        }
      }
    } else return "";
  }
  getEducationStatus(status: any) {
    let index, labelStatus;
    let num_id = 0;
    if (status) {
      num_id = typeof status === "object" ? status.id : parseInt(status);
      if (status && (this as any).educationStatus.length) {
        index = (this as any).educationStatus.findIndex((i: any) => {
          return i.id === num_id;
        });
        if (index >= 0) {
          labelStatus = (this as any).educationStatus[index].label;
          return labelStatus;
        }
      }
    } else return "";
  }
  getEducationCareer(career: any) {
    let index, labelCareer;
    if (career) {
      let num_id = typeof career === "object" ? career.id : parseInt(career);
      if (career && (this as any).educationCareer.length) {
        index = (this as any).educationCareer.findIndex((i: any) => {
          return i.id === num_id;
        });
        if (index >= 0) {
          labelCareer = (this as any).educationCareer[index].label;
          return labelCareer;
        }
      }
    } else return "";
  }
  changeUser(newUser: any) {
    (this as any).user = newUser;
  }
  writeNumber() {
    this.notPhone = false;
    this.errorPhone.flag = true;
    this.errorPhone.type = "";
  }
  cancelExp() {
    (this as any).workExp = {
      title: "",
      nucleusTypeId: "",
      company: "",
      from: "",
      to: "",
      description: "",
      current_job: false
    };
    this.add_edit_experience = false;
    this.user_edit = true;
    this.no_pointer = false;
  }
  editExp(index: any, experience: any) {
    (this as any).user.users_experiences[index] = experience;
    (this as any).user_exp[index] = experience;
  }
  async newUser() {
    const _this: any = this;
    await _this.$root.reloadUser();
    _this.user = _this.$store.state.user;
    if (_this.user.about === "null") _this.user.about = "";
    _this.user_exp = [];
    setTimeout(() => {
      _this.user_exp = _this.$store.state.user.users_experiences;
    }, 250);
  }
  from_profile(event: any) {
    if (event) {
      (this as any).$refs.container_file.style.pointerEvents = "none";
    }
  }
  showModal() {
    (this as any).$refs["delete_modal"].show();
  }
  async cancel_profile_personal() {
    (this as any).toggleViewState("profile");
    await (this as any).$root.reloadUser();
    (this as any).user = (this as any).$store.state.user;
  }
}
